import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Axios from "axios";

import Visibility from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";

import { url } from "../../../../../config/config";
import SignUpForm from "../SignUpForm/SignUpForm";
import { useStyles } from "./AuthorSignUp.css";

class AuthorSignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        firstName: "",
        middleName: "",
        lastName: "",
        phone: "",
        description: "",
        email: "",
        password: "",
        confirmPassword: "",
      },
      error: {
        firstNameError: "",
        lastNameError: "",
        phoneError: "",
        descriptionError: "",
        emailError: "",
        passwordError: "",
        confirmPasswordError: "",
      },
      successMessage: "",
      showPassword: false,
      showConfirmPassword: false,
      success: "",
      termsAccept: false,
      loading: false,
    };
  }

  handleChange = (e) => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value },
    });
  };

  showPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: true })}
      />
    );
  };

  hidePassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showPassword: false })}
      />
    );
  };

  showConfirmPassword = () => {
    return (
      <Visibility
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: true })}
      />
    );
  };

  hideConfirmPassword = () => {
    return (
      <VisibilityOffIcon
        style={{ cursor: "pointer" }}
        onClick={() => this.setState({ showConfirmPassword: false })}
      />
    );
  };

  checkError = (EmailError, PhoneError) => {
    let firstNameError = "";
    let lastNameError = "";
    let phoneError = PhoneError ? "Use Only Numbers" : "";
    let descriptionError = "";
    let emailError = EmailError;
    let passwordError = "";
    let confirmPasswordError = "";

    if (this.state.data.firstName.length < 3) {
      firstNameError = "First Name must be minimum of 3 characters";
    }
    if (this.state.data.lastName.length < 3) {
      lastNameError = "Last Name must be minimum of 3 characters";
    }
    if (this.state.data.phone.length < 10) {
      phoneError = "Phone Number must be of minimum length 10";
    }
    if (this.state.data.description.length < 3) {
      descriptionError = "Description must be of minimum length 3";
    }
    if (this.state.data.password.length < 8) {
      passwordError = "Password must be minimum of 8 characters";
    }
    if (this.state.data.confirmPassword !== this.state.data.password) {
      confirmPasswordError = "Password must be matched";
    }
    if (
      firstNameError ||
      lastNameError ||
      emailError ||
      phoneError ||
      descriptionError ||
      passwordError ||
      confirmPasswordError
    ) {
      this.setState({
        error: {
          firstNameError,
          lastNameError,
          phoneError,
          descriptionError,
          emailError,
          passwordError,
          confirmPasswordError,
        },
      });
      return true;
    } else {
      this.setState({
        error: {
          firstNameError: "",
          lastNameError: "",
          phoneError: "",
          descriptionError: "",
          emailError: "",
          passwordError: "",
          confirmPasswordError: "",
        },
      });
      return false;
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      this.setState({ loading: true });
      let response = [];
      let data = {
        firstName: this.state.data.firstName,
        middleName: this.state.data.middleName,
        lastName: this.state.data.lastName,
        email: this.state.data.email,
        phone: this.state.data.phone,
        password: this.state.data.password,
        description: this.state.data.description,
        imageUrl: "",
      };
      response = await Axios.post(`${url}/api/authors`, data);
      if (response.data.emailError || response.data.errors) {
        this.setState({ loading: false });
        if (response.data.emailError) {
          this.checkError(response.data.emailError, "");
        } else {
          this.checkError("", response.data.message);
        }
      } else {
        if (response.data.success) {
          this.setState({
            success: response.data.success,
          });
          this.props.history.push("/login/Author");
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <SignUpForm
            loading={this.state.loading}
            label="Author"
            data={this.state.data}
            error={this.state.error}
            handleChange={this.handleChange}
            handleSubmit={this.handleSubmit}
          />

          <br />
          <div style={{ display: "flex", justifyContent: "center" }}>
            Already have account?&nbsp; <Link to="/login/Author">Login</Link>
          </div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            Go to &nbsp;<Link to="/">Home</Link>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(AuthorSignUp));
